var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "quiz__users" }, [
    _c("img", {
      attrs: {
        src: _vm.mediaBaseUrl + "quiz/users/rewards.png",
        alt: "rewards"
      }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "img" }, [
      _c("img", {
        attrs: {
          src: _vm.mediaBaseUrl + "quiz/covers/" + _vm.gender + "/users.png",
          alt: ""
        },
        on: {
          load: function($event) {
            return _vm.$emit("imageLoaded")
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("header", [
      _c("h2", [_vm._v("1,008,326 " + _vm._s(_vm.$t("quiz.list[4].people")))]),
      _vm._v(" "),
      _c("p", [_vm._v(_vm._s(_vm.$t("quiz.list[4].joined")))])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }